<template>
  <div>
    <v-content fluid>
      <div
        v-for="category in categories"
        :key="category.id"
        flat
        class="overflow-y-auto mx-2"
        style="margin-bottom:60px; overflow-x:hidden !important;"
      >
        <div v-if="category.name" class="text-center my-2">
          <div
            class="headline"
            :id="'select' + category.id"
            v-if="category.name != ''"
          >{{ category.name }}</div>
          <hr />
        </div>
        <ProductPreview
          @selectProduct="$emit('selectProduct', product)"
          @addProduct="addedProduct => $emit('addProduct', addedProduct)"
          v-for="product in category.products"
          :key="product.id"
          :product="product"
        />
      </div>
      <!-- <v-footer absolute class="text-center">
        <a href="merlocode.com">Powered by MerloCode</a>
      </v-footer>-->
    </v-content>
  </div>
</template>
<script>
import ProductPreview from "@/components/ProductPreview";

export default {
  name: "productList",
  components: { ProductPreview },
  props: ["categories"]
};
</script>
